import { render } from "./FileInvoice.vue?vue&type=template&id=6571dd00&scoped=true"
import script from "./FileInvoice.vue?vue&type=script&lang=js"
export * from "./FileInvoice.vue?vue&type=script&lang=js"

import "./FileInvoice.vue?vue&type=style&index=0&id=6571dd00&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6571dd00"]])

export default __exports__